import { Slider  } from "@mantine/core";

// TODO fix types and rater
export const Rater = ({ steps, id, onClick, initialValue, disabled }: any) => {

  const marks = steps.map((step: string, index: number) => ({
    value: Number(index) + 1,
    label: step,
  }));

  return (
    <Slider
      disabled={disabled}
      defaultValue={Number(initialValue)}
      onChangeEnd={(value) => {
        onClick(id, value);
      }}
      color="orange"
      marks={marks}
      label={(val) =>
        marks.find((mark: any) => mark.value === val && mark.label !== "")
          ?.label
      }
      step={1}
      max={5}
      min={1}
      size="xl"
      radius="xl"   
      showLabelOnHover={false}
      styles={(theme) => ({
        markLabel: { display: "none" },
        label: {
          backgroundColor: theme.colors.orange[0],
          fontSize: theme.fontSizes.md,
          color: theme.colors.dark,
          borderRadius: theme.spacing.md,
          padding: theme.spacing.xs,
        },
      })}
    />
  );
};
